export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <a href="#hero" className="font-heading text-xl font-bold text-foreground-900 mb-3 block">
              耽美漫画网
            </a>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              耽美漫画网专注为耽美爱好者提供免费耽美漫画与 BL 漫画高清在线阅读服务。全站海量资源每日更新，零门槛零付费，畅享纯粹的耽美阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">专题合集</a></li>
              <li><a href="#ranking" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">人气排行</a></li>
              <li><a href="#topics" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">热门话题</a></li>
              <li><a href="#cards" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">精选推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">热门分类</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">古风耽美</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">现代都市</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">校园青春</a></li>
              <li><a href="#index" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">奇幻异世</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              感谢各位漫画作者、正版授权平台及广大读者朋友对耽美漫画网的支持与信赖。
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 耽美漫画网 - 免费耽美漫画在线阅读平台
          </p>
          <p className="text-xs text-foreground-400">
            全站免费 · 每日更新 · 高清阅读
          </p>
        </div>
      </div>
    </footer>
  );
}